// gown-builder-variants.js
window.PaperDolls = window.PaperDolls || {};
window.PaperDolls.variants = window.PaperDolls.variants || {};
function getVariantOptionValue(product, variant, optionName) {
  if (!product || !variant || !product.options || !variant.options) return null;

  const index = product.options.findIndex(
    opt => opt && opt.toLowerCase() === optionName.toLowerCase()
  );

  if (index === -1) return null;
  return variant.options[index] || null;
}


console.log('Paper Dolls: variants module loaded');

/**
 * Filter variants to only those with BOTH:
 *  - a thumbnail image (Shopify variant image)
 *  - a preview PNG defined in window.variantPreviews[v.id]
 */
window.PaperDolls.variants.getVisibleVariants = function getVisibleVariants(product) {
  if (!product || !Array.isArray(product.variants)) return [];

  const previews = (window.variantPreviews || {});

  return product.variants.filter((v) => {
    const hasThumb =
      (v.featured_image && v.featured_image.src) ||
      v.image;

    const hasPreview = Boolean(previews[v.id]);

    return Boolean(hasThumb && hasPreview);
  });
};
